export function isAdmin($auth) {
	"ngInject";
	return () => $auth.isAuthenticated() && ($auth.getUser().permissions.split(",").indexOf("companies.manage") !== -1);
}

export function canManageUsers($auth) {
	"ngInject";
	return () => $auth.isAuthenticated() && ($auth.isAuthenticated() && ($auth.getUser().permissions.split(",").indexOf("companies.manage") !== -1) ||
	$auth.getUser().permissions.split(",").indexOf("user.company.manage") !== -1);
}

export function hasPermission($auth) {
	"ngInject";
	return (permission) => $auth.isAuthenticated() && ($auth.getUser().permissions.split(",").indexOf(permission) !== -1);
}


// WEBPACK FOOTER //
// ./sources/filters/isAdmin.js